import Properties from './Properties';
import reducer from './reducer';

export {
    reducer,
}

export default Properties